import { api } from '@/shared/api';
import type { operations } from '@/shared/api/autogen/schema';
import { AxiosError } from 'axios';

export type LuggageLocationResponse =
    operations['fetchApplicationLuggagesLocation']['responses']['200']['content']['application/json'];

/**
 * 荷物ロケーション履歴を取得する
 * @param applicationId - 申し込みID
 * @returns 荷物ロケーション履歴データ
 */
export const fetchLuggageLocation = async (applicationId: string): Promise<LuggageLocationResponse> => {
    try {
        return await api.get('/applications/{application_id}/luggages/location', {
            path: { application_id: applicationId },
        });
    } catch (error) {
        const axiosError = error as AxiosError;

        if (axiosError.status === 404) {
            throw new Error('荷物ロケーションデータがありません。');
        }
        throw new Error('荷物ロケーション履歴の取得中にエラーが発生しました。');
    }
};
